import { useState, createContext, useEffect, useCallback } from 'react';
import MyFunctions from '../Functions/MyFunctions';

export const CurrentPContext = createContext();

export const CurrentPContextProvider = props => {
    const [currentPage, setCurrentPage] = useState([]);

    return (
        <CurrentPContext.Provider value={[currentPage, setCurrentPage]}>
            {props.children}
        </CurrentPContext.Provider>
    )
}
